import React from "react";
import Header from "../HeaderOne/Main";
import Footer from "../FooterOne/Main";
import Breadcrumb from "../Breadcrumb/Main";
import CaseThree from "../Menservice/CaseThree";
import ServiceOne from "../Menservice/ServiceOne";
import FeaturesThreeSix from "../Menservice/FeaturesThreeSix";
import TestimonialSix from "../Menservicedtls/TestimonialSix";

function Main() {
  return (
    <div>
      <Header />
      <div className="main-wrapper">
        <div className="data-scroll">
          <div className="page-wrapper">
            <div className="page-wrapper-bg-2" />
            <div className="page-wrapper-bg-3" />
            <main className="site-main">
              <Breadcrumb title="Home" subtitle="Popular Services" />
              <FeaturesThreeSix />
              <ServiceOne />
              <CaseThree />
              <TestimonialSix />
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
